
        <iframe #iframe
                [src]="sourceUrlSafe$ | async"
                [style.-webkit-transform]="'scale(' + elementRef.nativeElement.clientWidth / 1920 + ')'">
        </iframe>
    